import { request } from '@/utils/request'

export function getUserInfo(userId) {
  return request({
    url: `/exam-user-base/${userId}`,
    method: 'get'
  })
}
